/**
 * WebRedirect - Shared redirect component for desktop settings pages
 *
 * On desktop (>= 768px), settings are accessed via modal from Dashboard.
 * All settings routes redirect to /dashboard if accessed directly.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function WebRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  return null;
}
